import { Component } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { CrmQuestionsResponse } from './crm-questions.response';

@Component({
  selector: 'gtd-crm-questions',
  templateUrl: './crm-questions.component.html',
})
export class CrmQuestionsComponent extends GtdNgWidgetComponentAbstract {
  protected readonly key: string = 'AffiliateCrm\\Answer\\QuestionAnswer';
  public data = new CrmQuestionsResponse();
  public answers = [];

  public afterData(): void {
    this.answers = this.data.questions.map((item) => {
      let answer: any[];
      let shortAnsw = '';
      let questionText = '';
      try {
        answer = JSON.parse(item.answer);
        answer = Array.isArray(answer) ? answer : [answer];
        answer = answer.filter((value) => value !== null);
        if (String(item.answer).length <= 30) {
          shortAnsw = answer.join(', ');
        }
      } catch {
        answer = Array.isArray(item.answer) ? item.answer : [item.answer];
      }
      try {
        questionText = JSON.parse(item.question).question;
      } catch {}
      return Object.assign(item, { answer, shortAnsw, questionText });
    });
  }
}
